import { createSlice } from '@reduxjs/toolkit';

import { MEMBER_REPORTING_SLICE_KEY } from './member-reporting.constants';
import { MemberReportingState } from './member-reporting.types';

const initialState: MemberReportingState = {
  dateRange: {
    fromDate: undefined,
    toDate: undefined,
  },
};

const memberReportingSlice = createSlice({
  name: MEMBER_REPORTING_SLICE_KEY,
  initialState,
  reducers: {
    setDateRange: (
      state,
      { payload }: { payload: MemberReportingState['dateRange'] },
    ) => {
      state.dateRange = payload;
    },
  },
});

export const memberReportingActions = memberReportingSlice.actions;
export const { reducer: memberReportingReducer } = memberReportingSlice;
